'use strict';

module.exports = returner;

function returner(value) {
  return value;
}
